import { useEffect } from "react";
import { envEnums } from "../enums/enums";
import { useParams } from "react-router-dom";

function useUpdateDomTitle(title,themeColor){

    const defaultTitle = process.env.REACT_APP_DOMAIN === envEnums.QGA ? 'View Page' : 'Scanned Page';

    useEffect(()=>{
        document.title = title ? title : defaultTitle;
        document.querySelector("meta[name=\"theme-color").content = themeColor ? themeColor : "#ffffff";
    })
}

export default useUpdateDomTitle;